import React from "react";
import ReactDOM from "react-dom/client";
import 'react-quill/dist/quill.snow.css';
import "jsvectormap/dist/css/jsvectormap.css";
import 'react-toastify/dist/ReactToastify.css';
import 'react-modal-video/css/modal-video.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { onForegroundMessage } from "./firebaseConfig";
import { AuthProvider } from "./context/AuthContext";

// Initialize FCM (Foreground listener)
onForegroundMessage();

// Optional: Request permission immediately on load (or move this to a user action like 'Enable Notifications' button)
// requestNotificationPermission(1); // Replace '1' with actual logged-in user ID

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);

reportWebVitals();
